export const menuData = [
  { title: 'Zur Person', link:'/about'},
  { title: 'Reiseleitung', link:'/Tour'},
  { title: 'Fotografie', link:'/Gallery'},
  { title: 'Onlineshop', link:'/shop'},
  { title: 'News', link:'/News'},
  // { title: 'Buchen', link:'/book'},
]
